<template>
<div class="z-main">
	<header class="z-header">
		<div><router-link to="/my"><img src="../../assets/sysbars/left.png" /></router-link></div>
		<div>平级查询</div>
		<div></div>
	</header>
	<div class="z-body z-body-bottom0">
		<div ref="mescroll" id="z-levelQuery-mescroll" class="mescroll">
			<div>
				<div v-for="(item,index) in data" class="z-subAccount-item">
					<div class="z-subAccount-user">
						<img :src="item.avatar" class="z-user-avatar">
						<div class="z-subAccount-info">
							<div v-text="item.name"></div>
							<div v-text="'交易号：'+(item.trade_account ? item.trade_account : '待入金')"></div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
</template>

<script>
export default {
	name: 'levelQuery',
	data() {
		return {
			data:[],
			mescroll: null,
		}
	},
	created() {
	},
	mounted() {
		this.mescrollInit()
	},
	methods: {
		// mescroll组件初始化的回调,可获取到mescroll对象
		mescrollInit () {
			let _this = this;
			_this.mescroll = new MeScroll("z-levelQuery-mescroll",{
				up:{
					callback: _this.upCallback
				}
			})
		},
		// 上拉回调 page = {num:1, size:10}; num:当前页 ,默认从1开始; size:每页数据条数,默认10
		upCallback (page, mescroll) {
			let _this = this
			_this.getList(page.num,function (rs) {

			})
		},
		getList(pageIndex,callback){
			let _this = this
			// 联网请求
			this.get('api/users/equalLevel', {
				page: pageIndex, // 页码
				limit: 15 // 每页长度
			}).then((rs) => {
				let arr = rs.data
				// 如果是第一页需手动置空列表
				if (pageIndex === 1) {
					_this.data = []
				}

				if (arr.length == 0) 
				{
					_this.$store.commit('layer','暂无数据')
				}
				else {
					// 把请求到的数据添加到列表
					_this.data = _this.data.concat(arr)
				}
				callback && callback(rs)
				// 数据渲染成功后,隐藏下拉刷新的状态
				_this.$nextTick(() => {
					_this.mescroll.endSuccess(arr.length)
				})
				
			}).catch((e) => {
				// 联网失败的回调,隐藏下拉刷新和上拉加载的状态;
				_this.mescroll.endErr()
			})
		},
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.z-subAccount-item {
	display: -webkit-flex;
	display: flex;
	justify-content:space-between;
	align-items:center;
	padding: 10px;
	border-bottom: 1px solid #27292F;
}
.z-subAccount-user {
	display: -webkit-flex;
	display: flex;
	justify-content:space-between;
	align-items:center;
}
.z-subAccount-info div:nth-child(2) {
	font-size: 10px;
	color: #9B9A9C;
}

.z-icon {
	width: 18px;
	height: 18px;
}
.z-gather-box {
	position: fixed;
	left: 0;
	right: 0;
	bottom: 0;
	width: 100%;
	background: #20232A;
	border-top: 2px solid #1E1F22;
}
.z-gather-btn{
	border-radius: 0px;
}
</style>



// WEBPACK FOOTER //
// src/pages/my/levelQuery.vue